export default __webpack_public_path__ + "static/media/logo-icon.76be6698.png";